<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">数据排名</span>
      </div>
    </div>
    <div class="filter-box">
      <span class="subtitle">查询方式：</span>
      <Dropdown @on-click="changeType">
        <Button>
          {{ type ? "消费" : "印量" }}
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem :name="0">印量</DropdownItem>
          <DropdownItem :name="1">消费</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <span class="subtitle" style="margin-left: 30px">查询时间：</span>
      <DatePicker
        type="date"
        v-model="page.start"
        placeholder="开始时间"
        style="width: 130px"
      ></DatePicker>
      <span style="margin: 0 5px">至</span>
      <DatePicker
        type="date"
        v-model="page.end"
        placeholder="结束时间"
        style="width: 130px"
      ></DatePicker>
      <Button style="margin-left: 5px" type="primary" @click="getData"
        >查询</Button
      >
      <Button style="margin-left: 5px" @click="reset">清空</Button>
    </div>
    <div style="position: relative">
      <div style="margin-top: 10px">
        <div style="width: 100%; height: 400px" ref="chartMachine"></div>
        <div style="width: 100%; height: 400px" ref="chartDepartment"></div>
        <div style="width: 100%; height: 400px" ref="chartStaff"></div>
      </div>
      <Spin fix v-if="tableLoad">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import echarts from "echarts";
import { monDiff, verifyDate } from "@/libs/util";
export default {
  data() {
    this.color = [
      "#2db7f5",
      "#19be6b",
      "#ff9900",
      "#ed4014",
      "#17233d",
      "#2d8cf0",
      "#3b9266",
      "#983fd0",
      "#442458",
      "#8aab26",
    ];
    return {
      tableLoad: true,
      type: 0, // 0 印量 1 消费
      page: {
        start: "",
        end: "",
      },
      machine: null,
      department: null,
      staff: null,
      startOptions: {
        disabledDate: (date) => {
          let data = this.page.end == "" ? Date.now() : this.page.end;
          return date >= data;
        },
      }, //开始日期设置
      endOptions: {
        // 指定终止日期
        disabledDate: (date) => {
          let data = this.page.start == "" ? "" : this.page.start;
          return date < data;
        },
      }, //结束日期设置
    };
  },
  mounted() {
    let now = new Date();
    let last = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    this.page.start = this.$moment(now, "YYYY-MM") + "-01";
    this.page.end = this.$moment(now, "YYYY-MM") + `-${last}`;

    this.getData();
  },
  methods: {
    getData() {
      if (verifyDate(this.page.start, this.page.end)) {
        //如果时间跨度超过一年就提示
        this.$Message.error("开始时间不能大于结束时间");
        return;
      }
      if (monDiff(this.page.start, this.page.end) > 3) {
        //如果时间跨度超过一年就提示
        this.$Message.error("筛选的时间跨度不能超过3个月");
        return;
      }
      this.tableLoad = true;
      let start = this.$moment(this.page.start, "YYYY-MM-DD"),
        end = this.$moment(this.page.end, "YYYY-MM-DD");
      this.GetChartData({
        type: this.type,
        start,
        end,
      }).then((res) => {
        this.initChart(res);
      });
    },
    formatOption(data) {
      return {
        title: {
          text: data.title,
          x: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          top: "8%",
          left: "1.2%",
          right: "1%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            label: {
              normal: {
                show: true,
                position: "insideTop",
                color: "#fff",
              },
            },
            data: data.series,
            type: "bar",
          },
        ],
      };
    },
    initChart(data) {
      let machine = {
        xData: [],
        series: [],
        title: `设备${this.type ? "消费" : "印量"}统计`,
      };
      let department = {
        xData: [],
        series: [],
        title: `部门${this.type ? "消费" : "印量"}统计`,
      };
      let staff = {
        xData: [],
        series: [],
        title: `员工${this.type ? "消费" : "印量"}统计`,
      };
      data.machine.map((item, index) => {
        machine.xData[index] = item.sn;
        machine.series[index] = {
          value: item.total,
          itemStyle: { color: this.color[index] },
        };
      });
      data.department.map((item, index) => {
        department.xData[index] = item.department_name;
        department.series[index] = {
          value: item.total,
          itemStyle: { color: this.color[index] },
        };
      });
      data.staff.map((item, index) => {
        staff.xData[index] = item.name;
        staff.series[index] = {
          value: item.total,
          itemStyle: { color: this.color[index] },
        };
      });
      let machineOption = this.formatOption(machine);
      let departmentOption = this.formatOption(department);
      let staffOption = this.formatOption(staff);

      this.machine = echarts.init(this.$refs.chartMachine);
      this.machine.setOption(machineOption);

      this.department = echarts.init(this.$refs.chartDepartment);
      this.department.setOption(departmentOption);

      this.staff = echarts.init(this.$refs.chartStaff);
      this.staff.setOption(staffOption);
      this.tableLoad = false;
    },
    changeType(name) {
      this.type = name;
      this.getData();
    },
    reset() {
      let now = new Date();
      let last = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      this.page.start = this.$moment(now, "YYYY-MM") + "-01";
      this.page.end = this.$moment(now, "YYYY-MM") + `-${last}`;
      this.type = 0;
      this.getData();
    },
    ...mapActions(["GetChartData"]),
  },
};
</script>

<style scoped>
</style>
